import { render, staticRenderFns } from "./PackageConfiguration.vue?vue&type=template&id=f013ed58&scoped=true&"
import script from "./PackageConfiguration.vue?vue&type=script&lang=js&"
export * from "./PackageConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PackageConfiguration.vue?vue&type=style&index=0&id=f013ed58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013ed58",
  null
  
)

export default component.exports